import { JSX } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { MODULE_VERSION_EXAMPLES_COLUMN_ID } from "../constants";
import { ModuleVersionExampleRow } from "../types";
import ModuleVersionExamplesTableNameCell from "./NameCell";

export const MODULE_VERSION_EXAMPLES_TABLE_CELLS: Record<
  MODULE_VERSION_EXAMPLES_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionExampleRow>) => JSX.Element
> = {
  [MODULE_VERSION_EXAMPLES_COLUMN_ID.NAME]: ModuleVersionExamplesTableNameCell,
};
